
import {useSelector} from "react-redux";

// import $ from 'jquery';
// window.jQuery = $;
// require('signalr');

const AccountsPayable = (props) => {
	const {DataCompany, ...auth} = useSelector(state => state.auth);
	console.log(auth)
	if (!DataCompany?.Token) {
		return <></>;
	}

	return (
		<iframe 
			title="unique"
			src={`${process.env.REACT_APP_IFRAME_V2_URL}/proveedores?token=${DataCompany.Token}&moduleId=${process.env.REACT_APP_MODULE_ID}&userId=10`}
        	style={{
				top: 0,
				left: 0,
				width: "100%",
				height: "100%",
				maxHeight: '100%',
				position: "border: none"
			}}        
        >
		</iframe>
	);
};

export default AccountsPayable;
